import "./faq.css";
import { FAQBOX } from "./FAQBOX";
import { Link, useParams } from "react-router-dom";
import { Custobtn } from "../Application/Custobtn";
import { GetStartedbtn } from "../Application/Getstartedbtn";
import { styled } from "@mui/material/styles";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import { useEffect, useState } from "react";
import Lottie from "lottie-react";
import faq from "../../Component/FILEJSON/other pages and includes/faq.json";
import back from "../../Component/FILEJSON/other pages and includes/Back.json";
import customer from "../../Component/FILEJSON/services/custom.json";
import website from "../../Component/FILEJSON/services/website.json";
import mobileapp from "../../Component/FILEJSON/services/mobileapp.json";
import ebook from "../../Component/FILEJSON/services/ebook.json";
import googlelinkedin from "../../Component/FILEJSON/services/google linkedin youtube ads.json";
import support from "../../Component/FILEJSON/services/livechat.json";
import socialmedia from "../../Component/FILEJSON/services/smm.json";
import uiux from "../../Component/FILEJSON/services/home design.json";
import seo from "../../Component/FILEJSON/services/home marketing.json";
import maintenance from "../../Component/FILEJSON/services/support.json";
import getStarted from "../../Component/FILEJSON/other pages and includes/Getstarted.json";
import contact from "../../Component/FILEJSON/other pages and includes/Contactpage.json";
import eCommerce from "../../Component/FILEJSON/other pages and includes/ecommercemanagement.json";
import customPatches from "../../Component/FILEJSON/other pages and includes/custompatchesServices.json";
import { Helmet } from "react-helmet";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { useMediaQuery } from "react-responsive";
import privacy from "../../Component/FILEJSON/other pages and includes/faq.json";
import '../Job/Job.css'
import '../Portfolio/portfolio.css'
import '../Testimonials/Testimonials.css';
import accountReinstatement from "../../Component/FILEJSON/services/AccountReinstatementicon.json";
const servicesmenu = [
  { id: 1, name: "All", animationData: faq, link: "All" },
  {
    id: 2,
    name: "Custom Development",
    animationData: customer,
    link: "custom-development",
  },
  {
    id: 3,
    name: "Website Development",
    animationData: website,
    link: "website-design-and-development",
  },
  {
    id: 4,
    name: "Mobile Application Development",
    animationData: mobileapp,
    link: "mobile-app-design-and-development",
  },
  {
    id: 5,
    name: "UI/UX and Graphic Designing",
    animationData: uiux,
    link: "uiux-and-graphic-designing",
  },
  { id: 6, name: "SEO and ASO", animationData: seo, link: "seo-and-aso" },
  {
    id: 7,
    name: "Ads Management",
    animationData: googlelinkedin,
    link: "ads-management",
  },
  {
    id: 8,
    name: "Social Media Marketing",
    animationData: socialmedia,
    link: "social-media-marketing",
  },
  {
    id: 13,
    name: "eCommerce Management",
    animationData: eCommerce,
    link: "eCommerce-management",
  },
  {
    id: 9,
    name: "Book and eBook Writing",
    animationData: ebook,
    link: "book-and-eBook-writing",
  },
  {
    id: 10,
    name: "Maintenance and Support",
    animationData: maintenance,
    link: "maintenance-and-support",
  },
  {
    id: 11,
    name: "Live Chat Support and Sales",
    animationData: support,
    link: "live-chat-support-and-sales",
  },
  {
    id: 12,
    name: "Promotional Branding",
    animationData: customPatches,
    link: "promotional-branding",
  },
  {
    id: 13,
    name: "Account Reinstatement",
    animationData: accountReinstatement,
    link: "account-reinstatement",
  },
];
const data1 = [
  {
    id: 1,
    slug: "custom-development",
    categoryname: "Custom Development",
    question:
      "Q1: What types of custom applications can DA Tech design and develop?",
    answer:
      "A: DA Tech specializes in crafting robust custom applications, including CRM, ERP, Custom Portals, eCommerce platforms, Service Booking systems, HRM Systems, Live Chat Boxes, Website Admin Panels, and POS Systems.",
  },
  {
    id: 2,
    slug: "custom-development",
    categoryname: "Custom Development",
    question: "Q2:  How does the custom development process work at DA Tech?",
    answer:
      "A: The custom development process at DA Tech involves a detailed consultation to understand your unique requirements, followed by the design, development, and testing phases, ensuring a tailored solution that meets your business needs.",
  },
  {
    id: 3,
    slug: "custom-development",
    categoryname: "Custom Development",
    question:
      "Q3: Can DA Tech integrate third-party APIs into custom applications?",
    answer:
      "A: Absolutely! DA Tech has expertise in seamlessly integrating third-party APIs to enhance the functionality and features of your custom applications.",
  },
  {
    id: 4,
    slug: "custom-development",
    categoryname: "Custom Development",
    question:
      "Q4: What security measures does DA Tech implement in custom development?",
    answer:
      "A: DA Tech prioritizes security and employs encryption, authentication, and authorization protocols to safeguard data and ensure the integrity of custom applications.",
  },
  {
    id: 5,
    slug: "custom-development",
    categoryname: "Custom Development",
    question:
      "Q5: Does DA Tech provide ongoing support for custom applications post-launch?",
    answer:
      "A: Yes, DA Tech offers comprehensive support and maintenance services to address any issues, implement updates, and ensure the optimal performance of custom applications.",
  },
  {
    id: 6,
    slug: "website-design-and-development",
    categoryname: "Website Development",
    question:
      "Q1: What is the approach to designing and developing custom websites at DA Tech?",
    answer:
      "A: DA Tech takes a comprehensive approach, starting with UIUX mockup designs, converting them into a frontend, and integrating an intuitive admin panel for seamless website management.",
  },
  {
    id: 7,
    slug: "website-design-and-development",
    categoryname: "Website Development",
    question: "Q2: Can DA Tech redesign an existing website?",
    answer:
      "A: Absolutely! DA Tech offers website redesign services to enhance the visual appeal, user experience, and functionality of your existing website.",
  },
  {
    id: 8,
    slug: "website-design-and-development",
    categoryname: "Website Development",
    question:
      "Q3: What technologies does DA Tech utilize for responsive website design?",
    answer:
      "A: DA Tech employs cutting-edge technologies like Bootstrap and CSS frameworks to ensure responsive and visually appealing designs for websites.",
  },
  {
    id: 9,
    slug: "website-design-and-development",
    categoryname: "Website Development",
    question:
      "Q4: How does DA Tech optimize websites for search engines during development?",
    answer:
      "A: DA Tech follows SEO best practices, optimizing website structures, content, and meta tags during development to enhance search engine visibility.",
  },
  {
    id: 10,
    slug: "website-design-and-development",
    categoryname: "Website Development",
    question:
      "Q5: Can DA Tech integrate e-commerce functionality into websites?",
    answer:
      "A: Yes, DA Tech specializes in integrating robust e-commerce features, providing seamless online shopping experiences for your customers.",
  },
  {
    id: 11,
    slug: "mobile-app-design-and-development",
    categoryname: "Mobile Application Development",
    question:
      "Q1: In which technologies does DA Tech specialize for mobile app development?",
    answer:
      "A: DA Tech excels in mobile app development using Flutter, Ionic, Swift, React Native, Kotlin, Java, Xarmin, and PhoneGap for both Android and iOS platforms.",
  },
  {
    id: 12,
    slug: "mobile-app-design-and-development",
    categoryname: "Mobile Application Development",
    question:
      "Q2: What is the process for developing a custom mobile application at DA Tech?",
    answer:
      "A: The process includes translating UIUX mockup designs into functional screens, integrating an admin panel for management, and thorough testing to ensure a seamless mobile app experience.",
  },
  {
    id: 13,
    slug: "mobile-app-design-and-development",
    categoryname: "Mobile Application Development",
    question:
      "Q3: Can DA Tech optimize mobile apps for different screen sizes and resolutions?",
    answer:
      "A: Absolutely! DA Tech ensures that mobile apps are optimized for various screen sizes and resolutions to provide a consistent and user-friendly experience.",
  },
  {
    id: 14,
    slug: "mobile-app-design-and-development",
    categoryname: "Mobile Application Development",
    question:
      "Q4: Does DA Tech provide cross-platform mobile app development services?",
    answer:
      "A: Yes, DA Tech offers cross-platform development, allowing apps to run on both Android and iOS devices, minimizing development time and costs.",
  },
  {
    id: 15,
    slug: "mobile-app-design-and-development",
    categoryname: "Mobile Application Development",
    question:
      "Q5: What measures does DA Tech take to ensure mobile app security?",
    answer:
      "A: DA Tech implements secure coding practices and conducts thorough security audits to protect mobile apps from potential vulnerabilities and unauthorized access.",
  },
  {
    id: 16,
    slug: "uiux-and-graphic-designing",
    categoryname: "UI/UX and Graphic Designing",
    question: "Q1: What design services does DA Tech offer?",
    answer:
      "A: DA Tech provides pixel-perfect design services, covering Logo design, Web and Mobile UIUX, Images, Icons, Stationary, Business Card design, and digitizing collaterals.",
  },
  {
    id: 17,
    slug: "uiux-and-graphic-designing",
    categoryname: "UI/UX and Graphic Designing",
    question: "Q2: Can DA Tech create a brand identity for my business?",
    answer:
      "A: Absolutely! DA Tech specializes in creating a cohesive brand identity through visually appealing and consistent design elements.",
  },
  {
    id: 18,
    slug: "uiux-and-graphic-designing",
    categoryname: "UI/UX and Graphic Designing",
    question:
      "Q3: How does DA Tech ensure a user-friendly design in UIUX projects?",
    answer:
      "A: DA Tech follows industry best practices, conducts user research, and employs intuitive design principles to ensure a user-friendly experience, enhancing overall user satisfaction.",
  },
  {
    id: 19,
    slug: "uiux-and-graphic-designing",
    categoryname: "UI/UX and Graphic Designing",
    question:
      "Q4: Can DA Tech redesign a logo while retaining the essence of our brand?",
    answer:
      "A: Certainly! DA Tech specializes in logo redesign, preserving brand identity elements while giving your logo a fresh and modern look.",
  },
  {
    id: 20,
    slug: "uiux-and-graphic-designing",
    categoryname: "UI/UX and Graphic Designing",
    question:
      "Q5: Can DA Tech create custom icons and images for my website or app?",
    answer:
      "A: Absolutely! DA Tech provides bespoke design services, including custom icons and images, ensuring a unique and visually appealing representation for your brand.",
  },
  {
    id: 21,
    slug: "seo-and-aso",
    categoryname: "SEO and ASO",
    question: "Q1: What SEO services does DA Tech offer?",
    answer:
      "A: DA Tech offers a range of SEO services, including On-page SEO, Off-page SEO, Local SEO, Technical SEO, and Mobile App SEO to enhance your online visibility and ranking.",
  },
  {
    id: 22,
    slug: "seo-and-aso",
    categoryname: "SEO and ASO",
    question:
      "Q2: How long does it take for SEO efforts to show results with DA Tech?",
    answer:
      "A: SEO timelines vary, but DA Tech implements strategic and ethical practices to enhance your online visibility. Results typically become noticeable within a few months.",
  },
  {
    id: 23,
    slug: "seo-and-aso",
    categoryname: "SEO and ASO",
    question:
      "Q3: Can DA Tech provide a comprehensive SEO audit for my website?",
    answer:
      "A: Yes, DA Tech conducts in-depth SEO audits, identifying areas for improvement in on-page, off-page, and technical aspects to boost your website's search engine ranking.",
  },
  {
    id: 24,
    slug: "seo-and-aso",
    categoryname: "SEO and ASO",
    question:
      "Q4: What ASO strategies does DA Tech employ to improve app visibility?",
    answer:
      "A: DA Tech focuses on optimizing app titles, descriptions, keywords, and visuals, ensuring your mobile app ranks higher and attracts more downloads on app stores.",
  },
  {
    id: 25,
    slug: "seo-and-aso",
    categoryname: "SEO and ASO",
    question:
      "Q5: How does DA Tech stay updated with search engine algorithm changes?",
    answer:
      "A: DA Tech's SEO team constantly monitors industry trends, attends conferences, and participates in continuous learning to adapt to search engine algorithm changes effectively.",
  },
  {
    id: 26,
    slug: "ads-management",
    categoryname: "Ads Management",
    question: "Q1: How can DA Tech boost my business with Google Ads?",
    answer:
      "A: DA Tech crafts targeted Google Ads campaigns tailored to your business niche, driving increased traffic, leads, and sales.",
  },
  {
    id: 27,
    slug: "ads-management",
    categoryname: "Ads Management",
    question: "Q2: What platforms does DA Tech manage ads on?",
    answer:
      "A: DA Tech manages ads on various platforms, including Google Ads, YouTube Ads, and LinkedIn Ads, ensuring a strategic and impactful online presence.",
  },
  {
    id: 28,
    slug: "ads-management",
    categoryname: "Ads Management",
    question:
      "Q3: How does DA Tech determine the target audience for Google Ads campaigns?",
    answer:
      "A: DA Tech conducts thorough market research to identify your target audience, refining Google Ads campaigns to reach the right demographic and increase conversion rates.",
  },
  {
    id: 29,
    slug: "ads-management",
    categoryname: "Ads Management",
    question: "Q4: Can DA Tech help in creating engaging content for ads?",
    answer:
      "A: Certainly! DA Tech provides content creation services, crafting compelling ad copy and visuals that resonate with your audience and drive engagement.",
  },
  {
    id: 30,
    slug: "ads-management",
    categoryname: "Ads Management",
    question:
      "Q5: What metrics does DA Tech track to measure the success of ads?",
    answer:
      "A: DA Tech tracks key metrics such as click-through rates, conversion rates, and return on investment (ROI) to assess the effectiveness of ads and optimize future campaigns.",
  },
  {
    id: 31,
    slug: "social-media-marketing",
    categoryname: "Social Media Marketing",
    question: "Q1: What social media services does DA Tech offer?",
    answer:
      "A: DA Tech provides comprehensive Social Media Marketing services, including strategy planning, post design, group engagement, and blog post scheduling for weekly and monthly activities.",
  },
  {
    id: 32,
    slug: "social-media-marketing",
    categoryname: "Social Media Marketing",
    question: "Q2: Can DA Tech help in building my brand on social media?",
    answer:
      "A: Absolutely! DA Tech excels in building and enhancing brand presence on social media platforms, attracting your target audience and increasing engagement.",
  },
  {
    id: 33,
    slug: "social-media-marketing",
    categoryname: "Social Media Marketing",
    question:
      "Q3: Does DA Tech create and manage social media advertising campaigns?",
    answer:
      "A: Yes, DA Tech develops and manages targeted social media advertising campaigns to promote your brand, products, and services to a wider audience.",
  },
  {
    id: 34,
    slug: "social-media-marketing",
    categoryname: "Social Media Marketing",
    question: "Q4: What social media platforms does DA Tech specialize in?",
    answer:
      "A: DA Tech specializes in various platforms, including but not limited to Facebook, Instagram, Twitter, LinkedIn, and Pinterest, tailoring strategies to each platform's unique audience.",
  },
  {
    id: 35,
    slug: "social-media-marketing",
    categoryname: "Social Media Marketing",
    question:
      "Q5: How does DA Tech measure the success of social media campaigns?",
    answer:
      "A: DA Tech uses analytics tools to track engagement, reach, and conversions, providing detailed reports to measure the success of social media campaigns and refine strategies accordingly.",
  },
  {
    id: 36,
    slug: "book-and-eBook-writing",
    categoryname: "Book and eBook Writing",
    question: "Q1: How does DA Tech's eBook writing service work?",
    answer:
      "A: DA Tech's eBook writing service involves expert writers turning your vision into compelling stories that captivate readers, elevating your brand and enhancing your online presence.",
  },
  {
    id: 37,
    slug: "book-and-eBook-writing",
    categoryname: "Book and eBook Writing",
    question: "Q2: Can DA Tech help me publish my book or eBook?",
    answer:
      "A: Yes, DA Tech can assist in the publishing process, ensuring your book or eBook reaches a wider audience through various online platforms.",
  },
  {
    id: 38,
    slug: "book-and-eBook-writing",
    categoryname: "Book and eBook Writing",
    question: "Q3: What genres does DA Tech cover in eBook writing?",
    answer:
      "A: DA Tech covers a wide range of genres, including business, fiction, non-fiction, self-help, technology, and more, ensuring diverse and captivating content for your audience.",
  },
  {
    id: 39,
    slug: "book-and-eBook-writing",
    categoryname: "Book and eBook Writing",
    question: "Q4: Does DA Tech provide ghostwriting services for books?",
    answer:
      "A: Absolutely! DA Tech offers ghostwriting services, allowing you to publish books under your name while benefiting from professional writing expertise.",
  },
  {
    id: 40,
    slug: "book-and-eBook-writing",
    categoryname: "Book and eBook Writing",
    question:
      "Q5: Can DA Tech assist in designing book covers and formatting eBooks?",
    answer:
      "A: Yes, DA Tech provides comprehensive services, including designing eye-catching book covers and formatting eBooks for various platforms, enhancing the overall appeal of your publications.",
  },
  {
    id: 41,
    slug: "maintenance-and-support",
    categoryname: "Maintenance and Support",
    question: "Q1: What ongoing maintenance services does DA Tech provide?",
    answer:
      "A: DA Tech offers ongoing maintenance and support services to keep your website or mobile application up-to-date, running smoothly, and addressing any issues promptly.",
  },
  {
    id: 42,
    slug: "maintenance-and-support",
    categoryname: "Maintenance and Support",
    question: "Q2: How can I avail DA Tech's support services?",
    answer:
      "A: You can avail DA Tech's support services by reaching out through our contact form or support channels. Our team will promptly assist with any queries or issues.",
  },
  {
    id: 43,
    slug: "maintenance-and-support",
    categoryname: "Maintenance and Support",
    question: "Q3: Does DA Tech offer emergency support for critical issues?",
    answer:
      "A: Yes, DA Tech provides emergency support for critical issues, ensuring quick resolution and minimal downtime for your digital assets.",
  },
  {
    id: 44,
    slug: "maintenance-and-support",
    categoryname: "Maintenance and Support",
    question:
      "Q4: Can DA Tech assist with website or app updates and feature additions?",
    answer:
      "A: Certainly! DA Tech helps with regular updates, feature additions, and improvements to ensure your website or app stays current and competitive.",
  },
  {
    id: 45,
    slug: "maintenance-and-support",
    categoryname: "Maintenance and Support",
    question:
      "Q5: What security measures does DA Tech implement for website and app maintenance?",
    answer:
      "A: DA Tech employs security patches, regular backups, and monitoring protocols to ensure the ongoing security of your website or mobile application during maintenance.",
  },
  {
    id: 51,
    slug: "live-chat-support-and-sales",
    categoryname: "Live Chat Support and Sales",
    question:
      "Q1: How does DA Tech's LiveChat Support and Sales service benefit my business?",
    answer:
      "A: DA Tech's LiveChat service provides 24/7 support to engage with website visitors, answer queries, and facilitate sales, contributing to a proactive customer support approach and lead generation.",
  },
  {
    id: 52,
    slug: "live-chat-support-and-sales",
    categoryname: "Live Chat Support and Sales",
    question: "Q2: Can DA Tech tailor LiveChat scripts to my business needs?",
    answer:
      "A: Absolutely! DA Tech customizes LiveChat scripts to align with your business needs, ensuring personalized interactions with visitors and potential customers.",
  },
  {
    id: 53,
    slug: "live-chat-support-and-sales",
    categoryname: "Live Chat Support and Sales",
    question:
      "Q3: Does DA Tech integrate LiveChat with CRM systems for lead management?",
    answer:
      "A: Yes, DA Tech integrates LiveChat with CRM systems, enabling efficient lead management, tracking, and follow-up for enhanced customer relationship management.",
  },
  {
    id: 54,
    slug: "live-chat-support-and-sales",
    categoryname: "Live Chat Support and Sales",
    question:
      "Q4: Can DA Tech provide multilingual LiveChat support for a global audience?",
    answer:
      "A: Certainly! DA Tech offers multilingual LiveChat support, allowing you to connect with a diverse audience and expand your reach globally.",
  },
  {
    id: 55,
    slug: "live-chat-support-and-sales",
    categoryname: "Live Chat Support and Sales",
    question:
      "Q5: How does DA Tech ensure data privacy and security in LiveChat interactions?",
    answer:
      "A: DA Tech prioritizes data privacy and security, employing encryption and secure protocols to safeguard customer information during Live Chat interactions.",
  },
  {
    id: 56,
    slug: "promotional-branding",
    categoryname: "Promotional Branding",
    question: "Q1: What is included in your Promotional Branding service?",
    answer:
      "A: Our Promotional Branding service covers a range of customized branding solutions, including custom patches (also known as monograms), metal badges, zippers, buttons, and various custom apparel such as t-shirts, hoodies, caps, beanies, and leather jackets. We tailor each product to meet your branding needs, ensuring that your logo and message are represented in the best possible way.",
  },
  {
    id: 57,
    slug: "promotional-branding",
    categoryname: "Promotional Branding",
    question:
      "Q2: Do you offer custom patches and metal badges in small quantities?",
    answer:
      "A: Yes, we cater to both small and bulk orders for custom patches and metal badges. Whether you need a few pieces for a small event or a large batch for corporate branding, our team ensures the same level of quality and attention to detail. This flexibility makes our service ideal for businesses of all sizes.",
  },
  {
    id: 58,
    slug: "promotional-branding",
    categoryname: "Promotional Branding",
    question:
      "Q3: How can custom patches and metal badges help with my branding?",
    answer:
      "A: Custom patches and metal badges are excellent tools for promoting your brand. They can be applied to uniforms, corporate apparel, and merchandise, making your brand more visible and professional. Whether you choose embroidered patches, woven labels, or precision-crafted metal badges, these accessories help to create a lasting impression on your customers.",
  },
  {
    id: 59,
    slug: "promotional-branding",
    categoryname: "Promotional Branding",
    question:
      "Q4: What regions do you serve with your Promotional Branding services?",
    answer:
      "A: We proudly serve clients across the USA, Canada, Europe, UAE, Australia, and New Zealand. As a top-rated exporter, we ensure that all custom patches, metal badges, and apparel meet international quality standards, and we deliver products on time to any of these regions. Our global reach allows us to support businesses looking to expand their brand visibility worldwide.",
  },
  {
    id: 60,
    slug: "promotional-branding",
    categoryname: "Promotional Branding",
    question:
      "Q5: How can I place an order for custom apparel like t-shirts, hoodies, and caps?",
    answer:
      "A: Placing an order for custom apparel is simple! Just get started from the top bar and signup. Then place your order with design and requirements, and we'll guide you through the process. We offer custom t-shirts, hoodies, caps, and jackets tailored to your specifications, including design, fabric choice, and branding elements like patches and badges. Our team will work with you to ensure that the final product meets your branding goals perfectly.",
  },
  {
    id: 61,
    slug: "eCommerce-management",
    categoryname: "eCommerce Management",
    question: "Q1: What does your eCommerce Management service include?",
    answer:
      "A: Our eCommerce Management service offers a complete solution for managing online stores across various platforms like Amazon, eBay, Walmart, Etsy, and Shopify. We handle everything from product listing optimization, inventory management, order fulfillment, customer service, and account health monitoring. Additionally, we provide specialized services such as Amazon PPC campaigns, eCommerce SEO, and platform-specific account management to boost sales and improve the overall performance of your online store.",
  },
  {
    id: 62,
    slug: "eCommerce-management",
    categoryname: "eCommerce Management",
    question:
      "Q2: How can your eCommerce Management services improve my sales?",
    answer:
      "A: We focus on several key areas to drive growth and increase sales for your eCommerce business: • Optimized Product Listings: We ensure your products are SEO-optimized with the right keywords, images, and descriptions for better visibility in search results. • PPC Advertising: Our team runs data-driven Amazon PPC and other ad campaigns to bring more traffic to your store. • Customer Service & Reviews: By managing customer queries and ensuring positive interactions, we help maintain good seller ratings, which directly impact sales. • Account Health Monitoring: We keep your account compliant with platform policies and avoid issues like suspensions, so your store runs smoothly without disruptions.",
  },
  {
    id: 63,
    slug: "eCommerce-management",
    categoryname: "eCommerce Management",
    question:
      "Q3: How do you manage multiple platforms like Amazon, eBay, Walmart, and Etsy?",
    answer:
      "A: We use a customized approach for each platform, ensuring that your store adheres to specific marketplace requirements and best practices. For example: • Amazon Seller Account Management: Includes optimizing product pages, monitoring seller account health, and managing Amazon PPC ads. • eBay Account Management: Focuses on listing optimization, handling customer inquiries, and ensuring eBay policies compliance. • Walmart & Etsy Account Management: We ensure product listings are well-optimized, compliant, and visible to potential customers. We also assist with strategies like improving product photography and keyword usage, tailored to the platform's unique audiences. Our team is experienced in managing multiple marketplaces simultaneously, ensuring smooth operations and growth across all channels.",
  },
  {
    id: 64,
    slug: "eCommerce-management",
    categoryname: "eCommerce Management",
    question: "Q4: How does your eCommerce Store SEO service work?",
    answer:
      "A: Our eCommerce Store SEO service is designed to improve your online store's search rankings on platforms like Amazon, Shopify, eBay, and more. We conduct: • Keyword Research: To identify high-traffic and relevant keywords for your products. • Competitor Analysis: We analyze what competitors are doing and ensure your listings stand out with optimized descriptions, titles, and tags. • On-Page Optimization: Our team optimizes each product page with rich, relevant content to improve visibility in both platform and external search engines like Google. • Content and Image Optimization: We ensure all product images and content adhere to SEO best practices for higher search rankings. Our goal is to drive more organic traffic to your store, resulting in increased visibility and sales.",
  },
  {
    id: 65,
    slug: "eCommerce-management",
    categoryname: "eCommerce Management",
    question:
      "Q5: How do you ensure my eCommerce accounts remain healthy and compliant with platform policies?",
    answer:
      "A: We closely monitor all accounts and platforms to ensure compliance with each platform's specific guidelines: • Account Health Monitoring: We constantly track your Amazon Seller Account Health, ensuring you're within performance metrics like order defect rate, valid tracking rate, and feedback score. • Policy Compliance: We make sure that your store is aligned with the latest policies of each platform to prevent account suspensions or penalties. • Reinstatement Support: In case of any issues such as ASIN or Account Suspensions, our team offers Amazon Seller Account Reinstatement and ASIN Reinstatement services to get your business back on track as quickly as possible. By ensuring your accounts stay healthy and compliant, we help you avoid downtime and potential loss of sales.",
  },
  {
    id: 66,
    slug: "account-reinstatement",
    categoryname: "Account Reinstatement",
    question:
      "Q1: What is account reinstatement?",
    answer:
      "A: Account reinstatement is the process of recovering a suspended or deactivated account by submitting an appeal with the required documentation and compliance measures.",
  },
  {
    id: 67,
    slug: "account-reinstatement",
    categoryname: "Account Reinstatement",
    question:
      "Q2: Which accounts can DA Tech reinstate?",
    answer:
      "A: We specialize in reinstating Amazon seller accounts, eBay seller accounts, Etsy stores, Walmart seller accounts, Facebook business pages, Instagram profiles, TikTok accounts, and LinkedIn accounts.",
  },
  {
    id: 68,
    slug: "account-reinstatement",
    categoryname: "Account Reinstatement",
    question:
      "Q3: How long does it take to reinstate an account?",
    answer:
      "A: The timeframe depends on the platform and the reason for suspension. Some accounts can be recovered within a few days, while others may take a couple of weeks.",
  },
  {
    id: 69,
    slug: "account-reinstatement",
    categoryname: "Account Reinstatement",
    question:
      "Q4: What are the common reasons for account suspension?",
    answer:
      "A: Common reasons include policy violations, intellectual property complaints, verification failures, and unusual activity. We analyze your case and provide tailored solutions.",
  },
  {
    id: 70,
    slug: "account-reinstatement",
    categoryname: "Account Reinstatement",
    question:
      "Q5: How can I increase my chances of successful reinstatement?",
    answer:
      "A: Ensure you provide accurate documents, follow platform policies, and avoid repeated violations. Our team can craft a strong appeal for the best chance of success.",
  },
];

const serviceLinks = {
  "custom-development":
    "https://hrm.datechmarketing.com/client-signup?service1=Custom_Development",
  "website-design-and-development":
    "https://hrm.datechmarketing.com/client-signup?service1=Website_Design_and_Development",
  "mobile-app-design-and-development":
    "https://hrm.datechmarketing.com/client-signup?service1=Mobile_App_Design_and_Development",
  "uiux-and-graphic-designing":
    "https://hrm.datechmarketing.com/client-signup?service1=UI/UX_and_Graphics",
  "seo-and-aso":
    "https://hrm.datechmarketing.com/client-signup?service1=SEO_and_ASO",
  "ads-management":
    "https://hrm.datechmarketing.com/client-signup?service1=Ads_Management",
  "social-media-marketing":
    "https://hrm.datechmarketing.com/client-signup?service1=Social_Media_Marketing",
  "eCommerce-management":
    "https://hrm.thedatech.com/client-signup?service1=eCommerce_Management",
  "book-and-eBook-writing":
    "https://hrm.datechmarketing.com/client-signup?service1=Book_and_eBook_Writing",
  "maintenance-and-support":
    "https://hrm.datechmarketing.com/client-signup?service1=Maintenance_and_Support",
  "live-chat-support-and-sales":
    "https://hrm.datechmarketing.com/client-signup?service1=Live_Chat_Support_and_Sales",
  "promotional-branding":
    "https://hrm.datechmarketing.com/client-signup?service1=Promotional_Branding",
    "account-reinstatement":
    "https://hrm.datechmarketing.com/client-signup?service1=Account_Reinstatement",
};

const FAQ = () => {
  const [isHover, setisHover] = useState(false);
  const [expanded, setExpanded] = useState(false);
  // const [isHover,setisHover]=useState(false);
  const [isback, setisback] = useState(false);
  const [filteredData, setFilteredData] = useState(data1);
  const [hoverStatesmenu, setHoverStatesmenu] = useState(null);
  const { slug } = useParams();

  console.log("SLUG IS ", slug);

  const handleMouseEnter1 = (id) => {
    setHoverStatesmenu(id);
  };

  const handleMouseLeave1 = () => {
    setHoverStatesmenu(null);
  };

  const BootstrapTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} arrow classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.arrow}`]: {
      color: theme.palette.common.black,
    },
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: theme.palette.common.black,
    },
  }));

  // Filter FAQ based on the category or slug
  const filterByCategory = (slug) => {
    if (!slug || slug.toLowerCase() === "all") {
      // Show all FAQ data if no slug or "All" is selected
      setFilteredData(data1);
    } else {
      // Otherwise, filter by categoryname or slug
      const filteredQuestions = data1.filter(
        (item) =>
          item.categoryname.toLowerCase() === slug.toLowerCase() ||
          item.slug?.toLowerCase() === slug.toLowerCase()
      );
      setFilteredData(filteredQuestions);
    }
    setExpanded([]); // Collapse all previously expanded items
  };

  // Automatically filter data by slug when component mounts or slug changes
  useEffect(() => {
    filterByCategory(slug);
  }, [slug]);

  let prevCategory = null;

  const schemaMarkup = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: [
      {
        "@type": "Question",
        name: "What services does DA Tech offer?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "DA Tech offers a range of services including Custom Development, Website Design, Mobile App Development, Graphic Designing, SEO, Social Media Marketing, and more.",
        },
      },
      {
        "@type": "Question",
        name: "Which regions does DA Tech serve?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "DA Tech serves clients globally, including regions like the USA, Canada, Europe, UAE, Australia, and New Zealand.",
        },
      },
      {
        "@type": "Question",
        name: "How can I contact DA Tech?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "You can contact DA Tech through our contact page at https://thedatech.com/contact or email us directly for a consultation.",
        },
      },
    ],
  };

  // const schemaMarkup= {
  //   "@context": "https://schema.org",
  //   "@type": "FAQPage",
  //   "mainEntity": [
  //     {
  //       "@type": "Question",
  //       "name": "What is account reinstatement?",
  //       "acceptedAnswer": {
  //         "@type": "Answer",
  //         "text": "Account reinstatement is the process of recovering a suspended or deactivated account by submitting an appeal with the required documentation and compliance measures."
  //       }
  //     },
  //     {
  //       "@type": "Question",
  //       "name": "Which accounts can DA Tech reinstate?",
  //       "acceptedAnswer": {
  //         "@type": "Answer",
  //         "text": "We specialize in reinstating Amazon seller accounts, eBay seller accounts, Etsy stores, Walmart seller accounts, Facebook business pages, Instagram profiles, TikTok accounts, and LinkedIn accounts."
  //       }
  //     },
  //     {
  //       "@type": "Question",
  //       "name": "How long does it take to reinstate an account?",
  //       "acceptedAnswer": {
  //         "@type": "Answer",
  //         "text": "The timeframe depends on the platform and the reason for suspension. Some accounts can be recovered within a few days, while others may take a couple of weeks."
  //       }
  //     },
  //     {
  //       "@type": "Question",
  //       "name": "What are the common reasons for account suspension?",
  //       "acceptedAnswer": {
  //         "@type": "Answer",
  //         "text": "Common reasons include policy violations, intellectual property complaints, verification failures, and unusual activity. We analyze your case and provide tailored solutions."
  //       }
  //     },
  //     {
  //       "@type": "Question",
  //       "name": "How can I increase my chances of successful reinstatement?",
  //       "acceptedAnswer": {
  //         "@type": "Answer",
  //         "text": "Ensure you provide accurate documents, follow platform policies, and avoid repeated violations. Our team can craft a strong appeal for the best chance of success."
  //       }
  //     }
  //   ]
  // }
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 1224px)" });
  return (
    <div className="servicemargin">
      <Helmet>
        <title>
        Digital Services based answers to your questions on design, development, digital marketing, business
        solutions and more
        </title>
        <meta
          name="description"
          content="Latest insights on design, development, digital marketing, business solutions and services. Get the
information you need to elevate your digital journey with us."
        />
        <meta
          name="keywords"
          content="design, development, digital marketing, business website, mobile application, paid ads, build a website,
uiux designing, live chat support and sales, grow a business, get rankings, get famous, digital services"
        />

        {slug !== "All" ? (
          <script type="application/ld+json">
            {JSON.stringify({
              "@context": "https://schema.org",
              "@type": "FAQs",
              mainEntity: filteredData?.map((item) => ({
                "@type": "Question",
                name: item?.question || "",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: item?.answer || "",
                },
              })),
            })}
          </script>
        ) : (
          <script type="application/ld+json">
            {JSON.stringify(schemaMarkup)}
          </script>
        )}
        {slug !== "All" ? (
          <link rel="canonical" href={`https://thedatech.com/faq/${slug}`} />
        ) : (
          <link rel="canonical" href="https://thedatech.com/services/account-reinstatement" />
          
        )}

        {/* <link rel="canonical" href="https://thedatech.com/services/account-reinstatement" /> */}
      </Helmet>
      <div className="row mx-2">
        <div className="col-1 mt-2">
          <BootstrapTooltip
            title="Previous Page"
            onMouseEnter={() => setisback(true)}
            onMouseLeave={() => setisback(false)}
          >
            <Link to="/">
              <Lottie
                animationData={back}
                loop={!isback}
                isStopped={!isback}
                autoplay={isback}
                style={{ width: 40, height: 40 }}
                id="backbtnport"
              />
            </Link>
          </BootstrapTooltip>
        </div>
        <div className="col-11 d-flex justify-content-md-center justify-content-center">
          {/* <h1 className="subpagestitle mx-1 mb-0 mt-3 mt-sm-2 faq-title-mob">
            FAQ's
          </h1> */}
          {/* <h1
              className="subpagestitle mb-0 mx-1 mt-1 mobilepara d-flex  justify-content-md-center justify-content-end"
              id="eightheight"
              onMouseEnter={() => setisHover(true)}
              onMouseLeave={() => setisHover(false)}
            >
              <Lottie
                animationData={privacy}
                loop={!isHover}
                isStopped={!isHover}
                autoplay={isHover}
                style={{ width: 30, height: 30 }}
                className="mt-2 privicon"
              />
              <span className="text-center subpagestitle mb-0 mt-2 priv-policy-heading-mob">
              FAQ's
              </span>
            </h1> */}
            <div className="col-11">
              <h1
                className="text-center emp-verification-mob-heading subpagestitle mb-0 d-flex justify-content-md-center justify-content-center"
                onMouseEnter={() => setisHover(true)}
                onMouseLeave={() => setisHover((currentValue) => !currentValue)}
              >
                <Lottie
                  animationData={privacy}
                  loop={!isHover}
                  isStopped={!isHover}
                  autoplay={isHover}
                  style={{ width: 40, height: 35, marginRight:"10px" }}
                  id="faqiconmain"
                  className="mt-0 mb-1 mailiconwidth desktop-icon-testimonial"
                />
                <span className="mt-1">FAQ's <small className="faq-icon-desk" style={{
                width:'30px', height:'60px', display: "inline-block",
     
              }}>
                <Lottie
                  animationData={privacy}
                  loop={!isHover}
                  isStopped={!isHover}
                  autoplay={isHover}
                  style={{ width: 40, height: 35 }}
                  id="faqiconmain icon-testimonial"
                  className="mt-0 mb-1 mailiconwidth mobile-icon-testimonial icon-testimonial contact-icon-mob"
                />
                </small></span>
              </h1>
            </div>
        </div>
      </div>
      <div className="btnsergridcontainer btnsergridcontainer-faq mt-2 mb-2">
        <div className="mx-md-3"></div>
        <Swiper
          slidesPerView={11}
          spaceBetween={10}
          className="mySwiper"
          breakpoints={{
            // when window width is >= 320px
            320: {
              slidesPerView: 4,
              spaceBetween: 5,
            },
            // when window width is >= 480px
            480: {
              slidesPerView: 6,
              spaceBetween: 5,
            },
            // when window width is >= 640px
            640: {
              slidesPerView: 11,
              spaceBetween: 10,
            },
          }}
        >
          {servicesmenu.map((menu) => {
            return (
              <SwiperSlide className="swiperfaqbgt" key={menu.id}>
                <BootstrapTooltip
                  title={menu.name}
                  onClick={() => filterByCategory(menu.name)}
                  onMouseEnter={() => handleMouseEnter1(menu.id)}
                  onMouseLeave={() => handleMouseLeave1(menu.id)}
                >
                  <Link to={`/faq/${menu.link}`} style={{ color: "#ff6600" }}>
                    <Lottie
                      animationData={menu.animationData}
                      loop={!hoverStatesmenu === menu.id}
                      isStopped={!hoverStatesmenu !== menu.id}
                      autoplay={hoverStatesmenu === menu.id}
                      id="servicemenuciricon"
                    />
                  </Link>
                </BootstrapTooltip>
              </SwiperSlide>
            );
          })}
        </Swiper>
      </div>
      <div className="row">
        <div className="col-md-7">
          <div className="faqboxcontainer mx-md-3 faq-box-mobile faq-box-desk">
            {filteredData &&
              filteredData.map(({ id, question, answer, categoryname }) => {
                const showCategory = categoryname !== prevCategory;
                prevCategory = categoryname;
                return (
                  <>
                    {showCategory && (
                      <h1
                        className="text-center"
                        style={{ color: "rgba(254,136,0,255)" }}
                      >
                        {categoryname}
                      </h1>
                    )}
                    <FAQBOX
                      key={id}
                      question={question}
                      answer={answer}
                      i={id}
                      expanded={expanded}
                      setExpanded={setExpanded}
                    />
                  </>
                );
              })}
          </div>
          {isTabletOrMobile && (
            <div
              className="d-flex justify-content-center fixedcontainerfaq mx-auto gap-md-4 faq-buttons-mobile"
              style={{ flexWrap: "wrap", width: "100%" }}
            >
              <Link
                to={
                  !slug || slug === "All"
                    ? "https://hrm.thedatech.com/client-signup"
                    : serviceLinks[slug]
                }
                target="_blank"
                onClick={(e) => {
                  e.preventDefault();
                  window.location.href =
                    !slug || slug === "All"
                      ? "https://hrm.thedatech.com/client-signup"
                      : serviceLinks[slug];
                }}
              >
                <GetStartedbtn btnvalue="GET STARTED" iconbtn={getStarted} />
              </Link>
              <Link to="/contact">
                <Custobtn btnvalue="Contact" iconbtn={contact} />
              </Link>
            </div>
          )}
        </div>

        {!isTabletOrMobile && (
          <div className="col-md-5 desktopview">
            <div id="faqimageright" className="mt-1">
              <img
                src="/services/aboutleft.gif"
                alt="A visual representation of DA Tech's comprehensive services, covering custom development, website
design, mobile app development, SEO, ads management, UIUX design, and more. Explore our FAQs to
gain insights and elevate your digital journey!"
                title="Frequently asked questions for web, mobile and digital marketing services"
                layout="responsive"
              />
            </div>
          </div>
        )}

        {!isTabletOrMobile && (
          <div
            className="d-flex justify-content-center fixedcontainerfaq mx-auto gap-4 faq-buttons-laptop faq-mob-buttons portfolio-buttons-moile"
            style={{ width: "100%" }}
          >
            <Link
              to={
                !slug || slug === "All"
                  ? "https://hrm.thedatech.com/client-signup"
                  : serviceLinks[slug]
              }
              // target="_blank"
              onClick={(e) => {
                e.preventDefault();
                window.location.href =
                  !slug || slug === "All"
                    ? "https://hrm.thedatech.com/client-signup"
                    : serviceLinks[slug];
              }}
            >
              <GetStartedbtn btnvalue="GET STARTED" iconbtn={getStarted} />
            </Link>
            <Link to="/contact">
              <Custobtn btnvalue="Contact" iconbtn={contact} />
            </Link>
          </div>
        )}
      </div>
    </div>
  );
};

export default FAQ;
